import { reactive } from 'vue';

const STORAGE_KEY = 'autooperator-show-images';
const HIDDEN_CLASS = 'images-hidden';

// Images are hidden by default; only an explicit saved "true" shows them.
export const imageVisibility = reactive({
  showImages: localStorage.getItem(STORAGE_KEY) === 'true',

  init() {
    this.apply();
  },

  toggle() {
    const willShow = !this.showImages;
    const message = willShow
      ? 'Show images? All images across the app will become visible.'
      : 'Hide images? All images across the app will be hidden.';

    if (!window.confirm(message)) {
      return;
    }

    this.showImages = willShow;
    localStorage.setItem(STORAGE_KEY, String(willShow));
    this.apply();
  },

  apply() {
    document.documentElement.classList.toggle(HIDDEN_CLASS, !this.showImages);
  }
});
